import { render, staticRenderFns } from "./PrintableForm.vue?vue&type=template&id=4ca5b3e4"
import script from "./PrintableForm.vue?vue&type=script&lang=ts"
export * from "./PrintableForm.vue?vue&type=script&lang=ts"
import style0 from "./PrintableForm.vue?vue&type=style&index=0&id=4ca5b3e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports